export const FEEDBACK_ICON_SIZE = 14;

export const FEEDBACK_BUTTONS_CLASS_NAME = 'ai-chat-feedback-buttons';

export const FeedbackButtonLabel = {
  THUMBS_UP: 'Helpful',
  THUMBS_DOWN: 'Not helpful',
};
